import './Footer.css'

export function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="jert-footer">
      <div className="footer-content">
        <div className="footer-left">
          <span className="footer-flag">
            <span className="flag-blue"></span>
            <span className="flag-white"></span>
            <span className="flag-red"></span>
          </span>
          <span className="footer-brand">Jertscript v2</span>
          <span className="footer-year">&copy; {currentYear}</span>
        </div>

        <div className="footer-center">
          <span className="footer-tagline">
            Made with <span className="footer-croissant" role="img" aria-label="croissant">&#x1F950;</span> and sarcasm
          </span>
        </div>

        <div className="footer-right">
          <a
            href="https://github.com/bfondue/jertscript"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            GitHub
          </a>
          <span className="footer-divider">|</span>
          <a
            href="https://github.com/bfondue/jertscript#readme"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            Docs
          </a>
          <span className="footer-divider">|</span>
          <span className="footer-credit">
            by <span className="credit-name">Jean</span>
          </span>
        </div>
      </div>

      <div className="footer-tricolor"></div>
    </footer>
  )
}
